import { NodeIndexOutlined } from "@ant-design/icons";
import * as React from "react";
import { loadValueThings } from "../../objectsApi";
import { GroupNode, ValueNode, attributeNode, groupNode } from "../model/node";
import { allowedActions } from "../model/permissions";
import { renderNodeTitle } from "./title";
import { KindContext, LazyKindHandler } from "./types";

/**
 * Группа, которой принадлежит значение. Нужна и для загрузки вложений,
 * и для проекции: у типа v1 groupId лежит прямо в узле.
 */
export const ownerGroupOf = (node: ValueNode, ctx: KindContext): GroupNode => {
  const owner = ctx.node(node.ownerId);
  if (owner?.kind !== "group") {
    throw Error(`Значение ${node.data.name} должно принадлежать группе`);
  }
  return owner;
};

export const valueKind: LazyKindHandler<ValueNode> = {
  // Значение справочника переименовать нельзя, поэтому замок ему не нужен
  title: (node) =>
    renderNodeTitle({
      name: node.data.name,
      id: node.data.id,
      displayId: node.data.displayId,
      disabled: false,
      placeholder: "",
    }),

  icon: () => <NodeIndexOutlined />,

  ownActions: () => allowedActions,

  isExpandable: () => true,

  children: async (node, ctx) => {
    const things = await loadValueThings(
      ownerGroupOf(node, ctx).data.id,
      node.data.id,
    );
    // Ответ уже содержит вложения конкретного значения справочника.
    // Фильтр valueId из childNodesOf скрыл бы их внутри собственной ветви.
    return [
      ...things.attributes.map((attr) => attributeNode(attr, node.id)),
      ...things.groups.map((group) => groupNode(group, node.id)),
    ];
  },

  // Справочники редактируются на своей вкладке: здесь форма только показывает
  // значение, но пустой результат ModelessForm не отобразит
  formData: async (node) => node.data,

  // Метода remove у значения нет, но вопрос всё равно должен называть узел
  removeMessage: () => "Удалить значение?",
};
